import { Injectable } from '@angular/core';

import { MaterialOrdemServico } from "./material-ordem-servico.model";
import { materialOrdensMaterialApiName } from "./data.service";
import { RestService } from "../../../../core/services/rest.service";

@Injectable()
export class MaterialOrdemServicoApiService {

    constructor(
        private _restService: RestService
    ) { }

    //materiais ordens material
    onPostMaterialOrdemServico(object: MaterialOrdemServico, done: any) {
        this._restService.onPost(materialOrdensMaterialApiName, object, done);
    }

    onPutMaterialOrdemServico(object: MaterialOrdemServico, done: any) {
        this._restService.onPut(materialOrdensMaterialApiName, object, done);
    }

    onDeleteMaterialOrdemServico(objectId: number, done: any) {
        this._restService.onDelete(materialOrdensMaterialApiName, objectId, done);
    }

    onGetAllMaterialOrdemServico(done: any) {
        let filter: any = {"include":["medida","material","ordemServico"]};
        this._restService.onGetPost(materialOrdensMaterialApiName, filter, done);
    }

    onGetByIdMaterialOrdemServico(objectId: number, done: any) {
        let filter: any = {"include":["material"]};
        this._restService.onGetPostId(materialOrdensMaterialApiName, objectId, filter, done);
    }

    onPostMateriaisOrdemServico(materiais: any, done: any) {
        this._restService.onPostCustom(materialOrdensMaterialApiName + '/bulk', materiais, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/materiais-ordem-servico/shared/material-ordem-servico-api.service.ts
 **/